import { Marker, Popup } from "react-leaflet";
import * as L from "leaflet";
import { PositionMsgType } from "./types";
import { PopupContent } from "./PopupContent";

// 20x20 icons
const icon20 = (url: string) => L.icon({ iconUrl: url, iconSize: [20, 20], iconAnchor: [10, 10] });
const lowIcon = icon20("/assets/icons/green-dot.svg");
const medIcon = icon20("/assets/icons/orange-dot.svg");
const highIcon = icon20("/assets/icons/red-dot.svg");

function computeDelaySeconds(p: PositionMsgType, mode: 1 | 2) {
  const gps = new Date(p.gpsTimestamp).getTime();
  const msg = new Date(p.messageTimestamp).getTime();
  const saved = p.timeSaved ? new Date(p.timeSaved).getTime() : msg;
  return mode === 1 ? (msg - gps) / 1000 : (saved - msg) / 1000;
}
function iconFor(p: PositionMsgType, mode: 1 | 2) {
  const d = computeDelaySeconds(p, mode);
  return d < 60 ? lowIcon : d < 1800 ? medIcon : highIcon;
}

export const MarkersLayer: React.FC<{
  points: PositionMsgType[];
  delayMode: 1 | 2;
}> = ({ points, delayMode }) => {
  return (
    <>
      {points.map((p, idx) => (
        <Marker key={idx} position={[p.gpsLatitude, p.gpsLongitude]} icon={iconFor(p, delayMode)}>
          <Popup><PopupContent p={p} /></Popup>
        </Marker>
      ))}
    </>
  );
};
